let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8R0Uw")).then(() => parcelRequire('d4C84'));